module.exports = __webpack_public_path__ + "img/write.237e390b.png";